import styled from 'styled-components';

export const TableSpinnerContainer = styled.div`
  padding: 5.6875rem 0;

  .spinner-icon {
    animation: spin 1s linear infinite;
    height: 2.5rem;
    object-fit: contain;
    width: 2.5rem;
  }
`;
